require("../node_modules/babel-polyfill/dist/polyfill.js");
require("../node_modules/whatwg-fetch/fetch.js");
require('assets/css/site.scss');
require('routes.tsx');
// HACK: daterangepicker requires jQuery on window
var $ = require('jquery');
// var moment: require('moment');
window['jQuery'] = $;
